export const PAYMENT_OPTIONS = {
  online: 'online',
  cash_upon_receipt: 'cash_upon_receipt',
};
